import React from 'react';

export const Arrow = () => {
  return (
    <svg
      width="11"
      height="8"
      viewBox="0 0 11 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3536 4.35356C10.5488 4.15829 10.5488 3.84171 10.3536 3.64645L7.17157 0.464467C6.97631 0.269205 6.65973 0.269205 6.46447 0.464467C6.2692 0.659729 6.2692 0.976312 6.46447 1.17157L9.29289 4L6.46447 6.82843C6.2692 7.02369 6.2692 7.34027 6.46447 7.53554C6.65973 7.7308 6.97631 7.7308 7.17157 7.53554L10.3536 4.35356ZM-8.57307e-08 4.5L10 4.5L10 3.5L8.57307e-08 3.5L-8.57307e-08 4.5Z"
        fill="black"
      />
    </svg>
  );
};
